import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import pl from './locales/pl/translation.json';
import en from './locales/en/translation.json';

// import zasobów bezpośrednio (możesz przenieść do oddzielnych plików JSON)
const resources = {
  en: {
    translation: en
  },
  pl: {
    translation: pl
  }
};

i18n
  .use(LanguageDetector) // automatyczne wykrywanie języka przeglądarki
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;